import { c as _c } from "react/compiler-runtime";
import CommonSelect from "@/components/utils/select/CommonSelect";
import type { XtdhCollectionsSortField } from "@/hooks/useXtdhCollectionsQuery";
import type { SortDirection } from "@/entities/ISort";
import { COLLECTION_SORT_ITEMS } from "../constants";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
interface XtdhCollectionsControlsProps {
  readonly activeSortField: XtdhCollectionsSortField;
  readonly activeSortDirection: SortDirection;
  readonly onSortChange: (sort: XtdhCollectionsSortField) => void;
  readonly searchTerm: string;
  readonly onSearchChange: (term: string) => void;
  readonly isDisabled?: boolean | undefined;
}
export function XtdhCollectionsControls(t0) {
  const $ = _c(15);
  const {
    activeSortField,
    activeSortDirection,
    onSortChange,
    searchTerm,
    onSearchChange,
    isDisabled: t1
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3"><MagnifyingGlassIcon className="tw-h-5 tw-w-5 tw-text-iron-400" aria-hidden="true" /></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== onSearchChange) {
    t3 = e => onSearchChange(e.target.value);
    $[1] = onSearchChange;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isDisabled || $[4] !== searchTerm || $[5] !== t3) {
    t4 = <div className="tw-relative tw-w-full sm:tw-max-w-xs md:tw-max-w-sm">{t2}<input type="text" value={searchTerm} onChange={t3} disabled={isDisabled} placeholder="Search collections..." className="tw-form-input tw-block tw-w-full tw-rounded-lg tw-border-0 tw-bg-iron-900 tw-py-2.5 tw-pl-10 tw-pr-3 tw-text-iron-100 tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 placeholder:tw-text-iron-500 hover:tw-ring-iron-600 focus:tw-bg-transparent focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 sm:tw-text-sm sm:tw-leading-6 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 tw-transition tw-duration-300 tw-ease-out" /></div>;
    $[3] = isDisabled;
    $[4] = searchTerm;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== activeSortDirection || $[8] !== activeSortField || $[9] !== isDisabled || $[10] !== onSortChange) {
    t5 = <div className="tw-w-full sm:tw-w-auto tw-overflow-x-auto horizontal-menu-hide-scrollbar"><CommonSelect items={COLLECTION_SORT_ITEMS} activeItem={activeSortField} filterLabel="Sort collections by" setSelected={onSortChange} sortDirection={activeSortDirection} disabled={isDisabled} fill={false} /></div>;
    $[7] = activeSortDirection;
    $[8] = activeSortField;
    $[9] = isDisabled;
    $[10] = onSortChange;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <section className="tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between tw-px-6" aria-label="Sort and search received collections">{t4}{t5}</section>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}